import Modal, { STEP } from './Modal.vue'

export default Modal
export { STEP }
